import { Save, Loader2, ArrowLeft } from 'lucide-react';

const Toolbar = ({
    onExport,
    onAddLayer,
    aspectRatio,            // passed but unused in UI now
    onAspectRatioChange,    // passed but unused in UI now
    selectedClipId,
    layers,
    onUpdateClip,
    onAutoFit,
    exportRatios = [],
    onToggleExportRatio,
    onSaveProject,
    isSaving = false,
    isExporting = false,
    selectedExportCount = 0,
    hasVariations = false,
    onBack
}) => {

    const exportLabel = hasVariations
        ? (selectedExportCount > 0 ? `Export (${selectedExportCount})` : 'Export All')
        : 'Export';

    return (
        <div className="video-editor-toolbar h-16 bg-white dark:bg-[#111111] border-b border-[#E5E7EB] dark:border-white/10 flex items-center justify-between px-6">

            <div className="flex items-center">
                {onBack ? (
                    <button
                        onClick={onBack}
                        aria-label="Back"
                        className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors"
                    >
                        <ArrowLeft className="w-4 h-4" />
                        <span>Back</span>
                    </button>
                ) : (
                    <div></div>
                )}
            </div>
            {/* Right Action Buttons */}
            <div className="video-editor-toolbar__actions flex items-center gap-3">
                <button
                    onClick={onSaveProject}
                    disabled={isSaving}
                    aria-label={isSaving ? "Saving project" : "Save project"}
                    className={`video-editor-toolbar__save flex items-center gap-2 px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${isSaving
                        ? 'bg-gray-100 dark:bg-white/5 text-gray-400 cursor-not-allowed'
                        : 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-white/10'
                        }`}
                >
                    {isSaving ? (
                        <Loader2 className="w-4 h-4 animate-spin" />
                    ) : (
                        <Save className="w-4 h-4" />
                    )}
                    <span>{isSaving ? 'Saving...' : 'Save'}</span>
                </button>

                <div className="h-6 w-px bg-gray-200 dark:bg-white/20 mx-1"></div>

                {/* Share Button (Visual only per screenshot implication) */}
                <button className="video-editor-toolbar__share px-4 py-2 bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg text-sm font-medium transition-colors">
                    Share
                </button>

                <button
                    onClick={onExport}
                    disabled={isExporting}
                    className={`video-editor-toolbar__export flex items-center gap-2 px-4 py-2 rounded-lg transition-colors font-medium border ${isExporting
                        ? 'bg-orange-400 text-white border-orange-400 cursor-not-allowed'
                        : 'bg-orange-600 hover:bg-orange-700 text-white border-orange-600'
                        }`}
                >
                    <span className="text-sm font-semibold">{isExporting ? 'Exporting...' : exportLabel}</span>
                </button>

            </div>
        </div>
    );
};

export default Toolbar;
